import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=1b11bf04&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "./Feedback.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b11bf04')) {
      api.createRecord('1b11bf04', component.options)
    } else {
      api.reload('1b11bf04', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=1b11bf04&", function () {
      api.rerender('1b11bf04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/Feedback.vue"
export default component.exports